import { Locale } from 'chaika-enums';
import { ruTranslations } from './ru';
import { enTranslations } from './en';
import { geTranslations } from './ge';
import { amTranslations } from './am';
import { ptTranslations } from './pt';
export const resources = {
    [Locale.Ru]: {
        translation: ruTranslations,
    },
    [Locale.En]: {
        translation: enTranslations,
    },
    [Locale.Ge]: {
        translation: geTranslations,
    },
    [Locale.Am]: {
        translation: amTranslations,
    },
    [Locale.Pt]: {
        translation: ptTranslations,
    },
};
export const localesList = Object.keys(resources);
export const minorLocales = localesList.filter(locale => locale !== Locale.Ru);
